import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ContractIdSelectionModal } from '@src/generic-components/ContractIdSelectionModal/components/ContractIdSelectionModal';
import { replaceActiveContractIdInSession } from './contractIdFilter';
import {
  closeContractIdEditor,
  contractIdSelectionApplied,
} from '@src/middleware/actions/common/common.actions';
import type { RootState } from '@src/store/reduxStore';
import { APP_EVENTS, APP_SESSION_KEYS } from '@src/constants/app-shell-constants';
import { ContractIdEditorHostContainer } from './ContractIdEditorHost.styles';

const ContractIdEditorHost: React.FC = () => {
  const dispatch = useDispatch();
  const editor = useSelector((state: RootState) => state.sharedState.contractIdEditor);

  if (!editor?.isOpen) {
    return null;
  }

  const handleApply = (selection: Parameters<typeof contractIdSelectionApplied>[0]) => {
    sessionStorage.setItem(APP_SESSION_KEYS.CONTRACT_ID_NAVIGATION, 'true');
    sessionStorage.setItem(
      APP_SESSION_KEYS.HI_VOLUME_CONTRACT_FLOW,
      selection.isBulkFlow ? 'true' : 'false'
    );
    sessionStorage.setItem(
      APP_SESSION_KEYS.SELECTED_CONTRACT_ID,
      selection.selectedContractIds.join(',')
    );
    replaceActiveContractIdInSession(null);
    window.dispatchEvent(
      new CustomEvent(APP_EVENTS.CONTRACT_ID_SCOPE_CHANGED, {
        detail: { selectedContractIds: selection.selectedContractIds },
      })
    );
    dispatch(contractIdSelectionApplied(selection));
  };

  return (
    <ContractIdEditorHostContainer>
      <ContractIdSelectionModal
        isOpen={editor.isOpen}
        contractIds={editor.contractIds}
        initialSelectedIds={editor.selectedIds}
        invalidContractIds={editor.invalidContractIds}
        isLoading={editor.isLoading}
        error={editor.error}
        onClose={() => dispatch(closeContractIdEditor())}
        onApply={handleApply}
      />
    </ContractIdEditorHostContainer>
  );
};

export default ContractIdEditorHost;
